/* eslint-disable */
// AUTO-GENERATED — do not edit manually.
// Regenerate with: pnpm gen:icons
//
// Source: src/features/icons/mapping.audit.md
//         designs/shared-icons/icons.json
import {
    AirplaneIcon as Airplane_Ph,
    ArrowDownIcon as ArrowDown_Ph,
    ArrowLeftIcon as ArrowLeft_Ph,
    BagSimpleIcon as BagSimple_Ph,
    BellIcon as Bell_Ph,
    CalendarIcon as Calendar_Ph,
    CarIcon as Car_Ph,
    CaretRightIcon as CaretRight_Ph,
    ChatCircleIcon as ChatCircle_Ph,
    CheckIcon as Check_Ph,
    CheckCircleIcon as CheckCircle_Ph,
    ChefHatIcon as ChefHat_Ph,
    CircleNotchIcon as CircleNotch_Ph,
    ClockIcon as Clock_Ph,
    ClockCounterClockwiseIcon as ClockCounterClockwise_Ph,
    CoinsIcon as Coins_Ph,
    CreditCardIcon as CreditCard_Ph,
    CrosshairIcon as Crosshair_Ph,
    EnvelopeIcon as Envelope_Ph,
    EyeIcon as Eye_Ph,
    EyeSlashIcon as EyeSlash_Ph,
    FileIcon as File_Ph,
    FireIcon as Fire_Ph,
    FunnelIcon as Funnel_Ph,
    HeartIcon as Heart_Ph,
    HouseIcon as House_Ph,
    LeafIcon as Leaf_Ph,
    ListIcon as List_Ph,
    MagnifyingGlassIcon as MagnifyingGlass_Ph,
    MapPinIcon as MapPin_Ph,
    MinusIcon as Minus_Ph,
    PackageIcon as Package_Ph,
    PaperPlaneRightIcon as PaperPlaneRight_Ph,
    PencilSimpleIcon as PencilSimple_Ph,
    PhoneIcon as Phone_Ph,
    PlantIcon as Plant_Ph,
    PlusIcon as Plus_Ph,
    ScanIcon as Scan_Ph,
    ShareNetworkIcon as ShareNetwork_Ph,
    ShoppingBagIcon as ShoppingBag_Ph,
    ShoppingCartIcon as ShoppingCart_Ph,
    SignOutIcon as SignOut_Ph,
    StarIcon as Star_Ph,
    StorefrontIcon as Storefront_Ph,
    TicketIcon as Ticket_Ph,
    TrashIcon as Trash_Ph,
    TruckIcon as Truck_Ph,
    UserIcon as User_Ph,
    WarningIcon as Warning_Ph,
    WarningCircleIcon as WarningCircle_Ph,
    XIcon as X_Ph,
} from '@phosphor-icons/react';
import {
    ArrowDown,
    ArrowLeft,
    Bell,
    Calendar,
    Car,
    Check,
    ChefHat,
    ChevronRight,
    CircleAlert,
    CircleCheckBig,
    Clock,
    Coins,
    CreditCard,
    Eye,
    EyeOff,
    File,
    Flame,
    Funnel,
    Heart,
    History,
    House,
    Leaf,
    LoaderCircle,
    LocateFixed,
    LogOut,
    Mail,
    MapPin,
    Menu,
    MessageCircle,
    Minus,
    Package,
    PackageCheck,
    Pencil,
    Phone,
    Plane,
    Plus,
    ScanLine,
    Search,
    Send,
    Share2,
    ShoppingBag,
    ShoppingCart,
    Star,
    Store,
    TicketPercent,
    Trash2,
    TriangleAlert,
    Truck,
    User,
    Wheat,
    X,
} from 'lucide-react';
import type { ComponentType, SVGProps } from 'react';
import WarningDefaultSVG from '@/assets/images/alert-triangle.svg';
import ArrowDownDefaultSVG from '@/assets/images/arrow-down.svg';
import ArrowLeftDefaultSVG from '@/assets/images/arrow-left.svg';
import BellDefaultSVG from '@/assets/images/bell.svg';
import CalendarDefaultSVG from '@/assets/images/calendar.svg';
import CarDefaultSVG from '@/assets/images/car.svg';
import CartDefaultSVG from '@/assets/images/cart.svg';
import CheckDefaultSVG from '@/assets/images/check.svg';
import ChefHatDefaultSVG from '@/assets/images/chef-hat.svg';
import ChevronRightDefaultSVG from '@/assets/images/chevron-right.svg';
import LoadingDefaultSVG from '@/assets/images/circle-dashed.svg';
import SuccessDefaultSVG from '@/assets/images/clipboard-check.svg';
import ClockDefaultSVG from '@/assets/images/clock.svg';
import CloseDefaultSVG from '@/assets/images/close.svg';
import CoinsDefaultSVG from '@/assets/images/coins.svg';
import CouponDefaultSVG from '@/assets/images/coupon.svg';
import CreditCardDefaultSVG from '@/assets/images/credit-card.svg';
import CurrentLocationDefaultSVG from '@/assets/images/current-location.svg';
import TruckFastDefaultSVG from '@/assets/images/delivery-car.svg';
import DroneDefaultSVG from '@/assets/images/drone.svg';
import EditDefaultSVG from '@/assets/images/edit.svg';
import MailDefaultSVG from '@/assets/images/email.svg';
import ErrorDefaultSVG from '@/assets/images/error-circle.svg';
import EyeOffDefaultSVG from '@/assets/images/eye-off.svg';
import EyeDefaultSVG from '@/assets/images/eye.svg';
import FireDefaultSVG from '@/assets/images/fire.svg';
import HeartFillDefaultSVG from '@/assets/images/heart-fill.svg';
import HeartDefaultSVG from '@/assets/images/heart.svg';
import HistoryDefaultSVG from '@/assets/images/history.svg';
import HomeDefaultSVG from '@/assets/images/home.svg';
import LeafDefaultSVG from '@/assets/images/leaf.svg';
import LogoutDefaultSVG from '@/assets/images/logout.svg';
import MapPinDefaultSVG from '@/assets/images/map-pin.svg';
import MenuDefaultSVG from '@/assets/images/menu.svg';
import MessageDefaultSVG from '@/assets/images/message.svg';
import MinusDefaultSVG from '@/assets/images/minus.svg';
import ShareDefaultSVG from '@/assets/images/mobile-share.svg';
import FileDefaultSVG from '@/assets/images/news.svg';
import PackageDefaultSVG from '@/assets/images/package.svg';
import PhoneDefaultSVG from '@/assets/images/phone.svg';
import PlusDefaultSVG from '@/assets/images/plus.svg';
import ScanDefaultSVG from '@/assets/images/scan-position.svg';
import FilterDefaultSVG from '@/assets/images/search-filter.svg';
import SearchDefaultSVG from '@/assets/images/search.svg';
import SendDefaultSVG from '@/assets/images/send.svg';
import ShoppingBagDoneDefaultSVG from '@/assets/images/shopping-bag-done.svg';
import BagDefaultSVG from '@/assets/images/shopping-bag.svg';
import StarFillDefaultSVG from '@/assets/images/star-fill.svg';
import StarDefaultSVG from '@/assets/images/star.svg';
import StoreDefaultSVG from '@/assets/images/store.svg';
import TrashDefaultSVG from '@/assets/images/trash.svg';
import UserDefaultSVG from '@/assets/images/user.svg';
import WheatDefaultSVG from '@/assets/images/wheat.svg';

// SVGR .svg imports are typed as image objects in svg.d.ts but emit React components at runtime.
type DefaultSvgComponent = ComponentType<SVGProps<SVGSVGElement>>;

export const ICON_MAP = {
    'arrow-down': {
        default: ArrowDownDefaultSVG as unknown as DefaultSvgComponent,
        lucide: ArrowDown,
        phosphor: ArrowDown_Ph,
        phosphorWeight: 'regular',
    },
    'arrow-left': {
        default: ArrowLeftDefaultSVG as unknown as DefaultSvgComponent,
        lucide: ArrowLeft,
        phosphor: ArrowLeft_Ph,
        phosphorWeight: 'regular',
    },
    bag: {
        default: BagDefaultSVG as unknown as DefaultSvgComponent,
        lucide: ShoppingBag,
        phosphor: ShoppingBag_Ph,
        phosphorWeight: 'regular',
    },
    bell: {
        default: BellDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Bell,
        phosphor: Bell_Ph,
        phosphorWeight: 'regular',
    },
    calendar: {
        default: CalendarDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Calendar,
        phosphor: Calendar_Ph,
        phosphorWeight: 'regular',
    },
    car: {
        default: CarDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Car,
        phosphor: Car_Ph,
        phosphorWeight: 'regular',
    },
    cart: {
        default: CartDefaultSVG as unknown as DefaultSvgComponent,
        lucide: ShoppingCart,
        phosphor: ShoppingCart_Ph,
        phosphorWeight: 'regular',
    },
    check: {
        default: CheckDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Check,
        phosphor: Check_Ph,
        phosphorWeight: 'regular',
    },
    'chef-hat': {
        default: ChefHatDefaultSVG as unknown as DefaultSvgComponent,
        lucide: ChefHat,
        phosphor: ChefHat_Ph,
        phosphorWeight: 'regular',
    },
    'chevron-right': {
        default: ChevronRightDefaultSVG as unknown as DefaultSvgComponent,
        lucide: ChevronRight,
        phosphor: CaretRight_Ph,
        phosphorWeight: 'regular',
    },
    clock: {
        default: ClockDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Clock,
        phosphor: Clock_Ph,
        phosphorWeight: 'regular',
    },
    close: {
        default: CloseDefaultSVG as unknown as DefaultSvgComponent,
        lucide: X,
        phosphor: X_Ph,
        phosphorWeight: 'regular',
    },
    coins: {
        default: CoinsDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Coins,
        phosphor: Coins_Ph,
        phosphorWeight: 'regular',
    },
    coupon: {
        default: CouponDefaultSVG as unknown as DefaultSvgComponent,
        lucide: TicketPercent,
        phosphor: Ticket_Ph,
        phosphorWeight: 'regular',
    },
    'credit-card': {
        default: CreditCardDefaultSVG as unknown as DefaultSvgComponent,
        lucide: CreditCard,
        phosphor: CreditCard_Ph,
        phosphorWeight: 'regular',
    },
    'current-location': {
        default: CurrentLocationDefaultSVG as unknown as DefaultSvgComponent,
        lucide: LocateFixed,
        phosphor: Crosshair_Ph,
        phosphorWeight: 'regular',
    },
    drone: {
        default: DroneDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Plane,
        phosphor: Airplane_Ph,
        phosphorWeight: 'regular',
    },
    edit: {
        default: EditDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Pencil,
        phosphor: PencilSimple_Ph,
        phosphorWeight: 'regular',
    },
    error: {
        default: ErrorDefaultSVG as unknown as DefaultSvgComponent,
        lucide: CircleAlert,
        phosphor: WarningCircle_Ph,
        phosphorWeight: 'regular',
    },
    eye: {
        default: EyeDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Eye,
        phosphor: Eye_Ph,
        phosphorWeight: 'regular',
    },
    'eye-off': {
        default: EyeOffDefaultSVG as unknown as DefaultSvgComponent,
        lucide: EyeOff,
        phosphor: EyeSlash_Ph,
        phosphorWeight: 'regular',
    },
    file: {
        default: FileDefaultSVG as unknown as DefaultSvgComponent,
        lucide: File,
        phosphor: File_Ph,
        phosphorWeight: 'regular',
    },
    filter: {
        default: FilterDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Funnel,
        phosphor: Funnel_Ph,
        phosphorWeight: 'regular',
    },
    fire: {
        default: FireDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Flame,
        phosphor: Fire_Ph,
        phosphorWeight: 'regular',
    },
    heart: {
        default: HeartDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Heart,
        phosphor: Heart_Ph,
        phosphorWeight: 'regular',
    },
    'heart-fill': {
        default: HeartFillDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Heart,
        lucideFilled: true,
        phosphor: Heart_Ph,
        phosphorWeight: 'fill',
    },
    history: {
        default: HistoryDefaultSVG as unknown as DefaultSvgComponent,
        lucide: History,
        phosphor: ClockCounterClockwise_Ph,
        phosphorWeight: 'regular',
    },
    home: {
        default: HomeDefaultSVG as unknown as DefaultSvgComponent,
        lucide: House,
        phosphor: House_Ph,
        phosphorWeight: 'regular',
    },
    leaf: {
        default: LeafDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Leaf,
        phosphor: Leaf_Ph,
        phosphorWeight: 'regular',
    },
    loading: {
        default: LoadingDefaultSVG as unknown as DefaultSvgComponent,
        lucide: LoaderCircle,
        phosphor: CircleNotch_Ph,
        phosphorWeight: 'regular',
    },
    logout: {
        default: LogoutDefaultSVG as unknown as DefaultSvgComponent,
        lucide: LogOut,
        phosphor: SignOut_Ph,
        phosphorWeight: 'regular',
    },
    mail: {
        default: MailDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Mail,
        phosphor: Envelope_Ph,
        phosphorWeight: 'regular',
    },
    'map-pin': {
        default: MapPinDefaultSVG as unknown as DefaultSvgComponent,
        lucide: MapPin,
        phosphor: MapPin_Ph,
        phosphorWeight: 'regular',
    },
    menu: {
        default: MenuDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Menu,
        phosphor: List_Ph,
        phosphorWeight: 'regular',
    },
    message: {
        default: MessageDefaultSVG as unknown as DefaultSvgComponent,
        lucide: MessageCircle,
        phosphor: ChatCircle_Ph,
        phosphorWeight: 'regular',
    },
    minus: {
        default: MinusDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Minus,
        phosphor: Minus_Ph,
        phosphorWeight: 'regular',
    },
    package: {
        default: PackageDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Package,
        phosphor: Package_Ph,
        phosphorWeight: 'regular',
    },
    phone: {
        default: PhoneDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Phone,
        phosphor: Phone_Ph,
        phosphorWeight: 'regular',
    },
    plus: {
        default: PlusDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Plus,
        phosphor: Plus_Ph,
        phosphorWeight: 'regular',
    },
    scan: {
        default: ScanDefaultSVG as unknown as DefaultSvgComponent,
        lucide: ScanLine,
        phosphor: Scan_Ph,
        phosphorWeight: 'regular',
    },
    search: {
        default: SearchDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Search,
        phosphor: MagnifyingGlass_Ph,
        phosphorWeight: 'regular',
    },
    send: {
        default: SendDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Send,
        phosphor: PaperPlaneRight_Ph,
        phosphorWeight: 'regular',
    },
    share: {
        default: ShareDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Share2,
        phosphor: ShareNetwork_Ph,
        phosphorWeight: 'regular',
    },
    'shopping-bag-done': {
        default: ShoppingBagDoneDefaultSVG as unknown as DefaultSvgComponent,
        lucide: PackageCheck,
        phosphor: BagSimple_Ph,
        phosphorWeight: 'regular',
    },
    star: {
        default: StarDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Star,
        phosphor: Star_Ph,
        phosphorWeight: 'regular',
    },
    'star-fill': {
        default: StarFillDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Star,
        lucideFilled: true,
        phosphor: Star_Ph,
        phosphorWeight: 'fill',
    },
    store: {
        default: StoreDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Store,
        phosphor: Storefront_Ph,
        phosphorWeight: 'regular',
    },
    success: {
        default: SuccessDefaultSVG as unknown as DefaultSvgComponent,
        lucide: CircleCheckBig,
        phosphor: CheckCircle_Ph,
        phosphorWeight: 'regular',
    },
    trash: {
        default: TrashDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Trash2,
        phosphor: Trash_Ph,
        phosphorWeight: 'regular',
    },
    'truck-fast': {
        default: TruckFastDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Truck,
        phosphor: Truck_Ph,
        phosphorWeight: 'regular',
    },
    user: {
        default: UserDefaultSVG as unknown as DefaultSvgComponent,
        lucide: User,
        phosphor: User_Ph,
        phosphorWeight: 'regular',
    },
    warning: {
        default: WarningDefaultSVG as unknown as DefaultSvgComponent,
        lucide: TriangleAlert,
        phosphor: Warning_Ph,
        phosphorWeight: 'regular',
    },
    wheat: {
        default: WheatDefaultSVG as unknown as DefaultSvgComponent,
        lucide: Wheat,
        phosphor: Plant_Ph,
        phosphorWeight: 'regular',
    },
} as const;

export type IconName = keyof typeof ICON_MAP;
